import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {
    this.getDiorToken()
   }
   mainDiorToken: any;

  private baseUrl = environment.apiBaseUrl;

  getDiorToken() {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      this.mainDiorToken = user?.jwt_token || null;
    } catch {
      this.mainDiorToken = null;
    }
  }

  private authHeaders(contentType?: string): HttpHeaders {
    const config: Record<string, string> = {};
    if (contentType) {
      config['Content-Type'] = contentType;
    }
    if (this.mainDiorToken) {
      config['Authorization'] = `Bearer ${this.mainDiorToken}`;
    }
    return new HttpHeaders(config);
  }

  submitReg(payload: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post(`https://belive-events.videostech.cloud/api/organizer/registerapi.php`, payload, { headers });
  }

  uploadDoc(payload: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post(`https://belive-events.videostech.cloud/api/organizer/upload_documents.php`, payload, { headers });
  }

  // submitOrganiserIndividual(payload: any) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });
  //   return this.http.post(`https://tikiti-organizer-api.videostech.cloud/api/v1/organizers`, payload,  { headers });
  // }  

  createOrganizer(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      // 'Authorization': `Bearer ${this.mainDiorToken}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      `${this.baseUrl}/leads`,
      payload,
      { headers }
    );
  }

  updateOrganizer(payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.put(
      `${this.baseUrl}/leads/${payload.organizer_id}`,
      payload,
      { headers }
    );
  }

  sendEmail(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      // 'Authorization': `Bearer ${this.mainDiorToken}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      `${this.baseUrl}/organizers/send-simple-otp`,
      payload,
      { headers }
    );
  }

  verifyOTP(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      // 'Authorization': `Bearer ${this.mainDiorToken}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      `${this.baseUrl}/organizers/verify-simple-otp`,
      payload,
      { headers }
    );
  }

  googleLogin(payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}${environment.googleLoginPath}`,
      payload,
      { headers }
    );
  }


  // legalOrganizer(id: any, payload: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.mainDiorToken}`,
  //     'Content-Type': 'application/json'
  //   });

  //   return this.http.put(
  //     `${this.baseUrl}/organizers/${id}`,
  //     payload,
  //     { headers }
  //   );
  // }

  submitPANCard(id: any, payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}/organizers/${id}/documents`,
      payload,
      { headers }
    );
  }

  // legalOrganizerUpdate(id: any, payload: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.mainDiorToken}`,
  //     'Content-Type': 'application/json'
  //   });

  //   return this.http.put(
  //     `${this.baseUrl}/leads/${id}`,
  //     payload,
  //     { headers }
  //   );
  // }

  submitBankDetails(id: any, payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}/organizers/${id}/bank-details`,
      payload,
      { headers }
    );
  }

  allCountry(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/countries`, { headers });
  }

  allState(id: any): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/states/${id}`, { headers });
  }

  allCities(id: any): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/cities/${id}`, { headers });
  }

  allDesignation(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/designations`, { headers });
  }

  allBusinessType(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/business-types`, { headers });
  }

  allCountryCode(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/countries-code`, { headers });
  }

  allEventCategeory(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/organizer-category-types`, { headers });
  }


  eventPerYears(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/events-per-year-ranges`, { headers });
  }


  getUniqueUserData(id:any): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/leads/${id}`, { headers });
  }


  audienceSize(): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.get<any>(`${environment.apiBaseUrl}/common/audience-size-ranges`, { headers });
  }

  // gstUploadDoucment(formData: any): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.mainDiorToken}`,
  //     'Content-Type': 'application/json'
  //   });
  //   return this.http.post<any>(`${environment.apiBaseUrl}/uploads/organizer-kyc`, formData, { headers });
  // }

  // gstUploadDoucment(formData: FormData): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.mainDiorToken}`,
  //     // 'Content-Type': 'application/json'
  //   });
  //   return this.http.post<any>(`${environment.apiBaseUrl}/uploads/organizer-kyc`, formData, { headers });
  // }

  // panUploadDoucment(formData: FormData): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.mainDiorToken}`,
  //     // 'Content-Type': 'application/json'
  //   });
  //   return this.http.post<any>(`${environment.apiBaseUrl}/uploads/organizer-kyc`, formData, { headers });
  // }

  uploadDoucment(formData: FormData): Observable<any> {
    const headers = this.authHeaders();
    return this.http.post<any>(`${environment.apiBaseUrl}/uploads/documents`, formData, { headers });
  }

  

  gstDocumentSubmit(userId: any, data: any): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.post<any>(`${this.baseUrl}/organizers/${userId}/documents`, data, { headers })
  }

  getDataOrganizerId(data: any): Observable<any> {
    const headers = this.authHeaders('application/json');
    return this.http.post<any>(`${this.baseUrl}/auth/token`, data, { headers })
  }


  submitAgreementDetails(id: any, payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}/organizers/${id}/bank-details/agreement-sign`,
      payload,
      { headers }
    );
  }

  verifyGSTDetails(payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}/kyc/gstin`,
      payload,
      { headers }
    );
  }

  verifyPANDetails(payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.post(
      `${this.baseUrl}/kyc/pan`,
      payload,
      { headers }
    );
  }

   updateAgreementID(id:any,payload: any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.put(
      `${this.baseUrl}/leads/${id}/skip-agreement-pdf`,
      payload,
      { headers }
    );
  }

  updateSKIPGST(payload: any,id:any): Observable<any> {
    const headers = this.authHeaders('application/json');

    return this.http.put(
      `${this.baseUrl}/leads/${id}/skip-gst`,
      payload,
      { headers }
    );
  }
}
